import { render, staticRenderFns } from "./FIBButton.vue?vue&type=template&id=a16b2170&scoped=true&"
import script from "./FIBButton.vue?vue&type=script&lang=js&"
export * from "./FIBButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a16b2170",
  null
  
)

export default component.exports
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(component, 'components', {QBtn});
